import Vue from 'vue';
import Vuex from 'vuex';

//import scales           from './modules/scales';
//import productDataList  from './modules/productDataList';
//import product          from './modules/product';
//import suppliers        from './modules/suppliers';
//import shipping         from './modules/shipping';


import company          from './modules/company';
import auth             from './modules/auth';


//import messages         from './modules/messages';

//import loader    from './modules/loader';

//import * as actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
	//actions,
	
	modules: 
	{

		auth,
		//scales,
		//product,
		//productDataList,
		//messages,
		//suppliers,
		//shipping,
		company
		//loader

	}
	
	
});